export const getButtonWidth = (optionsLength, isSmallOption = false) => {
  if (isSmallOption) {
    if (optionsLength < 8) {
      return '32%'
    }
    return '18.4%'
  }

  if (optionsLength === 2) {
    return '49%'
  } else if (optionsLength === 3) {
    return '32%'
  }

  return '23.5%'
}
